var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteBin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7674 8.71489H30.776V2.17872C30.776 0.975448 29.7918 0 28.5777 0H15.388C14.1739 0 13.1897 0.975448 13.1897 2.17872V8.71489H2.19828C0.984205 8.71489 0 9.69034 0 10.8936C0 12.0969 0.984205 13.0723 2.19828 13.0723H4.39656V45.7532C4.39656 46.9565 5.38077 47.9319 6.59485 47.9319H37.3708C38.5849 47.9319 39.5691 46.9565 39.5691 45.7532V13.0723H41.7674C42.9814 13.0723 43.9657 12.0969 43.9657 10.8936C43.9657 9.69034 42.9814 8.71489 41.7674 8.71489ZM17.5863 4.35745H26.3794V8.71489H17.5863V4.35745ZM8.79313 43.5745H35.1725V13.0723H8.79313V43.5745Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M21.9828 17.4297C20.7688 17.4297 19.7845 18.4051 19.7845 19.6084V37.0382C19.7845 38.2415 20.7688 39.2169 21.9828 39.2169C23.1969 39.2169 24.1811 38.2415 24.1811 37.0382V19.6084C24.1811 18.4051 23.1969 17.4297 21.9828 17.4297Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15.388 19.6094C14.1739 19.6094 13.1897 20.5848 13.1897 21.7881V34.8604C13.1897 36.0637 14.1739 37.0392 15.388 37.0392C16.6021 37.0392 17.5863 36.0637 17.5863 34.8604V21.7881C17.5863 20.5848 16.6021 19.6094 15.388 19.6094Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M26.3794 21.7881V34.8604C26.3794 36.0637 27.3636 37.0392 28.5777 37.0392C29.7918 37.0392 30.776 36.0637 30.776 34.8604V21.7881C30.776 20.5848 29.7918 19.6094 28.5777 19.6094C27.3636 19.6094 26.3794 20.5848 26.3794 21.7881Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteBin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleteBin.13eeb7dc39bbd450d573457c17d93049.svg";